<div #scrollContainer class="w-full p-20 bg-pastel-blue border-box h-full scroll-y flex flex-column gap-20">
  <ng-container *ngIf="step == 1">
    <app-poll-creation-round [(round)]="papValues.round"></app-poll-creation-round>
    <app-poll-creation-context [(round)]="papValues.round"
      [(electionContext)]="papValues.context"></app-poll-creation-context>
    <app-poll-creation-headcount [(headcount)]="papValues.headcount"
      (numberOfCollegesChange)="onNumberOfCollegesChanges()"
      (headcountChange)="onHeadcountChange($event)"></app-poll-creation-headcount>
    <app-pap-college [(colleges)]="papValues.colleges" (collegesChange)="onPapValuesChange()"
      [headcount]="papValues.headcount" [partial]="papValues.termLength.partial"></app-pap-college>
    <app-poll-creation-period [(period)]="papValues.period"></app-poll-creation-period>
  </ng-container>

  <ng-container *ngIf="step == 2">
    <app-poll-creation-sending-mode [(smsMode)]="poll.isSMS"></app-poll-creation-sending-mode>
    <app-poll-creation-security [(is2FA)]="poll.is2FA" [(password)]="poll.password"
      [(hasPassword)]="poll.hasPassword"  [(phoneChangeable)]="poll.phoneChangeable"></app-poll-creation-security>
    <app-poll-creation-sender [(sender)]="poll.sender" [electionImage]="poll.imageId"
      (imageChange)="handleElectionImageChange($event)"></app-poll-creation-sender>
    <app-poll-creation-title [(title)]="poll.title" [(description)]="poll.description"></app-poll-creation-title>
  </ng-container>

  <ng-container *ngIf="step == 3">
    <app-poll-creation-import (confirmVoters)="toStepFour()" [(voters)]="poll.voters"
    [is2FA]="poll.is2FA" [isSMS]="poll.isSMS" [hasSecurityQuestion]="poll.hasPassword"
    [votersConfirmed]="votersConfirmed" [canChangePhone]="poll.phoneChangeable"></app-poll-creation-import>
  </ng-container>
  <ng-container *ngIf="step == 4">
    <app-poll-creation-union [unions]="unions" (unionsChange)="onUnionsChange($event)" [colleges]="papValues.colleges"
    (onUnionImageChange)="onSendPollImage($event)" [voters]="poll.voters"  [(assessors)]="poll.assessors" [draftId]="poll.id"
    (assessorsValidated)="onAssessorsValidated()" [(collegeCandidatesData)]="collegeCandidatesData"
    [areAssessorsValidated]="areAssessorsValidated" [(validatedColleges)]="validatedColleges"
    [(unionValidatedEvent)]="areUnionsValidated"></app-poll-creation-union>
  </ng-container>

</div>
